import _ from 'lodash';
import {downloadBlobToFile} from '../../../../utils/CsvDownloadWithNulls';
import {displayFunctions} from './StoreTotalsDataSelections';

const toCsvValue = (value) => _.isNil(value) ? '' : JSON.stringify(value);

export function buildStoreTotalsCsv(retailerId, model, outlierIndex, selectedData) {
    const {valueKey, averageKey} = displayFunctions[selectedData];
    const header = [...model.columnDates, 'storeName', 'storeId', averageKey].join(',');
    const rows = model.rows.map(store => [
        ...model.columnDates.map(date => store.cells.get(date)?.cleansed?.[valueKey]),
        store.storeName,
        store.storeId,
        outlierIndex.averageFor(store.storeId)?.[averageKey]
    ].map(toCsvValue).join(','));
    return {csv: [header, ...rows].join('\r\n'), filename: `total_${valueKey}_retailerId_${retailerId}.csv`};
}

export function getStoreDataAsCsv(retailerId, model, outlierIndex, selectedData) {
    const {csv, filename} = buildStoreTotalsCsv(retailerId, model, outlierIndex, selectedData);
    downloadBlobToFile(new Blob([csv], {type: 'text/plain;charset=utf-8'}), filename);
}
